import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Nav from './Nav';
import Footer from './Footer';

export default function SiteLayout() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Nav />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>
      <Footer />
    </Box>
  );
}
